import { FormGroupSelectNumber } from "../../../../../../shared/react/Select";
import { FormGroupTextInput } from "../../../../../../shared/react/TextInput";
import { checkEmailAddress } from "../../../../../../shared/utils/format";
import { GenericProps, type NewInvite } from "../../types";
import { accessLevelOptions } from "./accessLevels";

interface Props extends GenericProps {
}

export function NewInvite({ state, dispatch }: Props) {

    const { api, invites: { newInvite } } = state
    const { email, accessLevel } = newInvite

    const canSend = email && Boolean(checkEmailAddress(email, false)) && Boolean(accessLevel)

    const update = (payload: Partial<NewInvite>) => dispatch({ type: "updateNewInvite", payload })

    const send = async () => {

        try {

            const invites = await api.sendNewInvite(newInvite)

            if (invites) {
                dispatch({ type: "load", payload: { invites } })
                update({ email: "", accessLevel: undefined })
            }

        } catch (error) {

            await api.errorHandler(error)

        }

    }

    return <div className="new-invite">

        <h2>
            <i className="fa-solid fa-paper-plane" />
            Send an invitation
        </h2>

        <p>
            To invite someone to become a member of this holding, please input their email address below,
            and click <b>Send</b>.
        </p>

        <p>
            When inviting new users to your account, always check whether you should remove any other users who should no longer have access.
        </p>

        <form className="form material-form">

            <div className="flex-row">

                <FormGroupTextInput
                    label="Email address"
                    className="email"
                    value={email ?? ""}
                    placeholder="Email address of the use to invite"
                    setValue={email => update({ email })}
                />

                <FormGroupSelectNumber
                    className="level"
                    value={accessLevel}
                    label="Initial access level"
                    defaultLabel="(Please select)"
                    setValue={accessLevel => update({ accessLevel })}
                    options={accessLevelOptions}
                />

                <button type="button" className="btn btn-link" disabled={!canSend} onClick={() => send()}>
                    <i className="fa-solid fa-paper-plane" />
                    &nbsp;Send
                </button>

            </div>

        </form>

    </div>

}
